import { render, staticRenderFns } from "./ModalEditPackage.vue?vue&type=template&id=49582069"
import script from "./ModalEditPackage.vue?vue&type=script&lang=js"
export * from "./ModalEditPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports